/* c8 ignore file */
/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import { MedicalFieldsDTO } from '@/components/patient/models/MedicalFieldsDTO'
import {
  AssignmentStrategyDTO,
  ConsultationRequestStatusDTO,
  FileKindEnum,
  GenderDTO,
  type OrganSupportDTO,
  ScheduledConsultationTypeDTO,
  ScopeBoundaryDTO,
  ShiftTypeDTO,
  UrgencyDTO,
  UserRightsEnum
} from '@/generated'

export const translateConsultationRequestStatusDTO = (
  status: ConsultationRequestStatusDTO | string,
  t: Function
): string => {
  switch (status) {
    case ConsultationRequestStatusDTO.CREATED:
      return t('Created')
    case ConsultationRequestStatusDTO.ACCEPTED:
      return t('Accepted')
    case ConsultationRequestStatusDTO.IN_PROGRESS:
      return t('In progress')
    case ConsultationRequestStatusDTO.REPORT_PENDING:
      return t('Consultation report pending')
    case ConsultationRequestStatusDTO.COMPLETED:
      return t('Completed')
    case ConsultationRequestStatusDTO.DELETED:
      return t('Deleted')
    default:
      return status
  }
}

export const translateMedicalFieldsDTO = (
  field: MedicalFieldsDTO | string,
  t: Function
): string => {
  switch (field) {
    case MedicalFieldsDTO.ANESTHESIOLOGY:
      return t('Anesthesiology')
    case MedicalFieldsDTO.CARDIAC_SURGERY_CARDIOTHORACIC_SURGERY:
      return t('Cardiac Surgery (Cardiothoracic Surgery)')
    case MedicalFieldsDTO.DERMATOLOGY:
      return t('Dermatology')
    case MedicalFieldsDTO.DIABETOLOGY:
      return t('Diabetology')
    case MedicalFieldsDTO.EMERGENCY:
      return t('Emergency Call')
    case MedicalFieldsDTO.GENERAL_SURGERY:
      return t('General Surgery')
    case MedicalFieldsDTO.GERIATRICS:
      return t('Geriatrics')
    case MedicalFieldsDTO.GYNECOLOGY:
      return t('Gynecology')
    case MedicalFieldsDTO.IMMUNOLOGY:
      return t('Immunology')
    case MedicalFieldsDTO.INFECTIOLOGY:
      return t('Infectiology')
    case MedicalFieldsDTO.INTENSIVE_CARE_MEDICINE:
      return t('Intensive Care')
    case MedicalFieldsDTO.INTERNAL_MEDICINE:
      return t('Internal Medicine')
    case MedicalFieldsDTO.INTERNAL_MEDICINE_AND_ANGIOLOGY:
      return t('Internal Medicine and Angiology')
    case MedicalFieldsDTO.INTERNAL_MEDICINE_AND_CARDIOLOGY:
      return t('Internal Medicine and Cardiology')
    case MedicalFieldsDTO.INTERNAL_MEDICINE_AND_ENDOCRINOLOGY_AND_DIABETOLOGY:
      return t('Internal Medicine and Endocrinology and Diabetology')
    case MedicalFieldsDTO.INTERNAL_MEDICINE_AND_GASTROENTEROLOGY:
      return t('Internal Medicine and Gastroenterology')
    case MedicalFieldsDTO.INTERNAL_MEDICINE_AND_HEMATOLOGY_AND_ONCOLOGY:
      return t('Internal Medicine and Hematology and Oncology')
    case MedicalFieldsDTO.INTERNAL_MEDICINE_AND_NEPHROLOGY:
      return t('Internal Medicine and Nephrology')
    case MedicalFieldsDTO.INTERNAL_MEDICINE_AND_PULMONOLOGY:
      return t('Internal Medicine and Pulmonology')
    case MedicalFieldsDTO.INTERNAL_MEDICINE_AND_RHEUMATOLOGY:
      return t('Internal Medicine and Rheumatology')
    case MedicalFieldsDTO.MICROBIOLOGY_VIROLOGY_AND_INFECTION_EPIDEMIOLOGY:
      return t('Microbiology, Virology, and Infection Epidemiology')
    case MedicalFieldsDTO.NEONATOLOGY:
      return t('Neonatology')
    case MedicalFieldsDTO.NEUROLOGY:
      return t('Neurology')
    case MedicalFieldsDTO.NEUROPEDIATRICS:
      return t('Neuropediatrics')
    case MedicalFieldsDTO.NEURORADIOLOGY:
      return t('Neuroradiology')
    case MedicalFieldsDTO.NEUROSURGERY:
      return t('Neurosurgery')
    case MedicalFieldsDTO.NUTRITIONAL_MEDICINE:
      return t('Nutritional Medicine')
    case MedicalFieldsDTO.OBSTETRICS:
      return t('Obstetrics')
    case MedicalFieldsDTO.OCCUPATIONAL_MEDICINE:
      return t('Occupational Medicine')
    case MedicalFieldsDTO.ONCOLOGY:
      return t('Oncology')
    case MedicalFieldsDTO.OPHTHALMOLOGY:
      return t('Ophthalmology')
    case MedicalFieldsDTO.ORAL_AND_MAXILLOFACIAL_SURGERY:
      return t('Oral and Maxillofacial Surgery')
    case MedicalFieldsDTO.ORTHOPEDICS_AND_TRAUMA_SURGERY:
      return t('Orthopedics and Trauma Surgery')
    case MedicalFieldsDTO.PALLIATIVE_MEDICINE:
      return t('Palliative Medicine')
    case MedicalFieldsDTO.PATHOLOGY:
      return t('Pathology')
    case MedicalFieldsDTO.PEDIATRIC_CARDIOLOGY:
      return t('Pediatric Cardiology')
    case MedicalFieldsDTO.PEDIATRIC_ENDOCRINOLOGY:
      return t('Pediatric Endocrinology')
    case MedicalFieldsDTO.PEDIATRIC_GASTROENTEROLOGY:
      return t('Pediatric Gastroenterology')
    case MedicalFieldsDTO.PEDIATRIC_HEMATOLOGY_AND_PEDIATRIC_ONCOLOGY:
      return t('Pediatric Hematology and Pediatric Oncology')
    case MedicalFieldsDTO.PEDIATRIC_PULMONOLOGY:
      return t('Pediatric Pulmonology')
    case MedicalFieldsDTO.PEDIATRICS:
      return t('Pediatrics')
    case MedicalFieldsDTO.PEDIATRIC_SURGERY:
      return t('Pediatric Surgery')
    case MedicalFieldsDTO.PHARMACOLOGY_AND_TOXICOLOGY:
      return t('Pharmacology and Toxicology')
    case MedicalFieldsDTO.PSYCHIATRY_AND_PSYCHOTHERAPY:
      return t('Psychiatry and Psychotherapy')
    case MedicalFieldsDTO.RADIATION_THERAPY:
      return t('Radiation Therapy')
    case MedicalFieldsDTO.RADIOLOGY:
      return t('Radiology')
    case MedicalFieldsDTO.SPECIALIZED_PAIN_THERAPY:
      return t('Specialized Pain Therapy')
    case MedicalFieldsDTO.THORACIC_SURGERY:
      return t('Thoracic Surgery')
    case MedicalFieldsDTO.UROLOGY:
      return t('Urology')
    case MedicalFieldsDTO.VASCULAR_SURGERY:
      return t('Vascular Surgery')
    case MedicalFieldsDTO.VISCERAL_SURGERY:
      return t('Visceral Surgery')
    default:
      return field
  }
}

export const translateMedicalFieldDTOs = (fields: string[], t: Function): string => {
  if (!fields || fields.length === 0) {
    return ''
  }

  const translatedFields = fields.map((field) => translateMedicalFieldsDTO(field, t))

  return translatedFields.join(', ')
}

export const translateShiftTypeDTO = (
  shiftType: ShiftTypeDTO | string,
  t: Function,
  shortLabel: boolean = false
): string => {
  switch (shiftType) {
    case ShiftTypeDTO.FIRST_SHIFT:
      return shortLabel ? t('1st shift') : t('First Shift')
    case ShiftTypeDTO.BACKUP_SHIFT:
      return shortLabel ? t('2nd shift') : t('Backup Shift')
    case ShiftTypeDTO.NO_SHIFT:
      return t('No Shift')
    case ShiftTypeDTO.GOD_MODE:
      return t('Routing and Patient Viewer')
    case ShiftTypeDTO.CHIEF_PHYSICIAN:
      return t('Routing and Patient Supervisor')
    default:
      return shiftType
  }
}

export const translateUserRightsEnum = (
  userRights: UserRightsEnum | string,
  t: Function
): string => {
  switch (userRights) {
    case UserRightsEnum.GOD_MODE:
      return t('Routing and Patient Viewer')
    case UserRightsEnum.CHIEF_PHYSICIAN:
      return t('Routing and Patient Supervisor')
    case UserRightsEnum.HOSPITAL_IT:
      return t('Hospital IT')
    case UserRightsEnum.TCC_IT:
      return t('TCC IT')
    case UserRightsEnum.TCC_PHYSICIAN:
      return t('TCC Physician')
    case UserRightsEnum.HOSPITAL_PHYSICIAN:
      return t('Hospital Physician')
    case UserRightsEnum.EASY_RADIOLOGY:
      return t('Easy Radiology')
    default:
      return userRights
  }
}

export const translateFileKindEnum = (fileKind: FileKindEnum | string, t: Function): string => {
  switch (fileKind) {
    case FileKindEnum.MEDICAL_REPORT:
      return t('Medical Reports')
    case FileKindEnum.CONSULTATION_REPORT:
      return t('Consultation Reports')
    case FileKindEnum.SCHEDULED_CONSULTATION_REPORT:
      return t('Scheduled Consultation Reports')
    case FileKindEnum.DOCUMENTS:
      return t('Documents')
    default:
      return fileKind
  }
}

export const translateUrgencyDTO = (
  urgency: UrgencyDTO,
  t: Function,
  shortLabel: boolean = false
): string => {
  switch (urgency) {
    case UrgencyDTO.EMERGENCY:
      return shortLabel ? t('Emergency') : t('Emergency Call')
    case UrgencyDTO.URGENT:
      return t('Urgent')
    case UrgencyDTO.ROUTINE:
      return t('Routine')
    case UrgencyDTO.FOLLOW_UP:
      return t('Follow Up')
    default:
      return urgency
  }
}

export const translateFullGenderDTO = (gender: GenderDTO, t: Function) => {
  switch (gender) {
    case GenderDTO.MALE:
      return t('Male')
    case GenderDTO.FEMALE:
      return t('Female')
    case GenderDTO.VARIOUS:
      return t('Other')
    case GenderDTO.NOT_DEFINED:
      return t('Not defined')
    default:
      return t('Unknown')
  }
}

export const translateGenderDTO = (gender: GenderDTO | string, t: Function): string => {
  switch (gender) {
    case GenderDTO.MALE:
      return t('m')
    case GenderDTO.FEMALE:
      return t('f')
    case GenderDTO.VARIOUS:
      return t('v')
    case GenderDTO.NOT_DEFINED:
      return t('n.d.')
    default:
      return gender
  }
}

export const translateScheduledConsultationTypeDTO = (
  type: ScheduledConsultationTypeDTO | string,
  t: (key: string) => string
): string => {
  switch (type) {
    // [UI-Only] Map `PATIENT_VISIT` to "Ward Round" per client request.
    // The backend DTO value remains unchanged to avoid breaking changes
    // during the current environment stabilization phase.
    case ScheduledConsultationTypeDTO.PATIENT_VISIT:
      return t('Ward Round')
    case ScheduledConsultationTypeDTO.CONFERENCE:
      return t('Case Conference')
    case ScheduledConsultationTypeDTO.PATIENT_PRESENTATION:
      return t('Patient Presentation')
    default:
      return type
  }
}

export const translateOrganSupportDTO = (
  organSupportType: keyof OrganSupportDTO,
  t: (key: string) => string
): string => {
  switch (organSupportType) {
    case 'dialysis':
      return t('Dialysis')
    case 'vasopressors':
      return t('Vasopressors')
    case 'ventilation':
      return t('Ventilation')
    case 'ecmo':
      return t('ECMO')
    case 'impella':
      return t('Impella')
    default:
      return organSupportType
  }
}

export const translateConsultationStatusLog = (
  status: ConsultationRequestStatusDTO,
  t: (key: string) => string
): string => {
  switch (status) {
    case ConsultationRequestStatusDTO.CREATED: {
      return t('In escalation')
    }
    case ConsultationRequestStatusDTO.ACCEPTED: {
      return t('Assigned')
    }
    case ConsultationRequestStatusDTO.IN_PROGRESS: {
      return t('In progress')
    }
    case ConsultationRequestStatusDTO.REPORT_PENDING: {
      return t('Consultation report pending')
    }
    case ConsultationRequestStatusDTO.COMPLETED: {
      return t('Completed')
    }
    case ConsultationRequestStatusDTO.DELETED: {
      return t('Deleted')
    }
    default:
      return status
  }
}

export const translateAssignmentStrategyDTO = (
  strategy: AssignmentStrategyDTO,
  t: (key: string) => string
): string => {
  switch (strategy) {
    case AssignmentStrategyDTO.SINGLE: {
      return t('Single Routing')
    }
    case AssignmentStrategyDTO.BROADCAST: {
      return t('Broadcast')
    }
    default:
      return strategy
  }
}

export const translateScopeBoundaryDTO = (
  scopeBoundary: ScopeBoundaryDTO,
  t: (key: string) => string
): string => {
  switch (scopeBoundary) {
    case ScopeBoundaryDTO.CLIENT:
      return t('All in Network')
    case ScopeBoundaryDTO.HOSPITAL:
      return t('Within Hospital')
    case ScopeBoundaryDTO.DEPARTMENT:
      return t('Within Department')
    case ScopeBoundaryDTO.WARD:
      return t('Within Ward')
    case ScopeBoundaryDTO.HOSPITAL_HUB:
      return t('Selected Hospitals')
    default:
      return scopeBoundary
  }
}
